<template>
  <LoadingScreen id="loading-screen" />
</template>

<script>
import LoadingScreen from "@/components/LoadingScreen.vue";
import Swal from "sweetalert2";

export default {
  components: { LoadingScreen },
  name: "ExternalAuth",
  mounted() {
    let self = this;
    let title = "External Authentication - Dating4Pets";
    document.title = title;
    self.$router.push("/");

    const query = window.location.search;
    const getParameters = new URLSearchParams(query);
    let jwt = getParameters.get("jwt");
    if (jwt == null) {
      self.$router.push("/");
    } else {
      if (jwt != "0" && !getParameters.get("error")) {
        localStorage.setItem("jwt", jwt);
        self.$router.push("/");
      } else {
        if (getParameters.get("error")) {
          let errorMessage = "";
          let date = new Date();
          switch (getParameters.get("error")) {
            case "100":
              errorMessage =
                "There already is an acount with this email. Try loging in with your <span class='ggl-text'>Google</span> account.";
              break;
            case "101":
              errorMessage =
                "There already is an acount with this email. Try loging in with your <span class='fb-text'>Facebook</span> account.";
              break;
            case "102":
              errorMessage =
                "There already is an acount with this email. Try loging in using your <span class='fb-text'>Email</span> and <span class='ggl-text'>Password</span>.";
              break;
            default:
              errorMessage = `There was an error while trying to log you in. Please report it by clicking <a href='mailto:dating4pets@protonmail.com?subject=Error Report, ${date}&body=Reporting a bug encounter while trying to log in using social media. Error response: ${getParameters.get(
                "error"
              )}. Please get back to me as soon as possible!'>here</a>`;
              break;
          }
          Swal.fire({
            title: "An error occured",
            html: `${errorMessage}`,
            icon: "error",
          })
            .then(() => {
              self.$router.push("/");
            })
            .catch((err) => {
              Swal.fire("An unknown error occured", `${err}`, "error");
            });
        } else {
          Swal.fire(
            "An error occured",
            "Something whent wrong during your authentication.",
            "error"
          )
            .then(() => {
              self.$router.push("/");
            })
            .catch((err) => {
              Swal.fire("An error occured", `${err}`, "error");
            });
        }
      }
    }
  },
};
</script>
